module.exports = __webpack_public_path__ + "static/media/Button_Disclosure_Blue_Down.744ae0fa.png";